export const version = process.env.REACT_APP_COMMIT_HASH
